import { FC } from 'react';
import { useController } from 'react-hook-form';

import { IntlPhoneNumber, IntlPhoneNumberProps } from '../base';

interface RhfIntlPhoneNumberProps extends IntlPhoneNumberProps {
  control: any;
  name: string;
}

const RhfIntlPhoneNumber: FC<RhfIntlPhoneNumberProps> = ({
  control,
  name,
  label,
  placeholder,
  fullWidth,
  disabled,
  ...otherProps
}) => {
  const {
    field: { onChange, onBlur, value, ref },
    fieldState: { error }
  } = useController({
    name,
    control,
    defaultValue: ''
  });

  return (
    <IntlPhoneNumber
      label={label}
      // helperText={error?.message}
      placeholder={placeholder}
      disabled={disabled}
      error={error ? true : false}
      onChange={onChange} // send value to hook form
      onBlur={onBlur} // notify when input is touched/blur
      value={value} // input value
      name={name} // send down the input name
      inputRef={ref} // send input ref, so we can focus on input when error appear
      fullWidth={fullWidth}
      {...otherProps}
    />
  );
};

export { RhfIntlPhoneNumber };
